import { Alert } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function StudentWarnings({ warnings, onRemove }) {
	const { t } = useTranslation();
	return warnings.map(({ id, name }) => (
		<Alert key={id} variant="warning" onClose={() => onRemove(id)} dismissible>
			{t('trainings.enrollment_student_warning', { name })}
		</Alert>
	));
}

StudentWarnings.propTypes = {
	warnings: PropTypes.array,
	onRemove: PropTypes.func,
};
